import { createFileRoute } from "@tanstack/react-router";
import { referralsInfiniteQueryOptions } from "@/lib/client/referral";
import { userPointsQueryOptions } from "@/lib/client/user";
import { UserspacePage } from "@/features/user/userspace-page";

export const Route = createFileRoute("/_index/_authed/userspace")({
  component: RouteComponent,
  loader: async ({ context: { queryClient } }) => {
    return {
      points: await queryClient.prefetchQuery(userPointsQueryOptions),
      referrals: queryClient.prefetchInfiniteQuery(referralsInfiniteQueryOptions()),
    };
  },
});

function RouteComponent() {
  const { user } = Route.useRouteContext();
  return <UserspacePage user={user!} />;
}
